/* eslint-disable react/no-unescaped-entities */
import cx from "classnames";
import React, { useState } from "react";

import { BasicButton } from "@gaming/xds-react-js";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { StreamingEuDataProviders, StreamingEuStep, StreamingEuStepDefaultProps } from "../models";
import {
  AccessEntitlementDataParagraph1,
  AccessEntitlementDataParagraph2,
  StreamingButtonLabels,
  StreamingEntitlementsTitles,
  StreamingEuStepTitle,
} from "../streamingEuContent";
import * as styles from "../StreamingEuPage.module.css";
import { StreamingEuCloseButton } from "./StreamingEuCloseButton";

const renderInput = (
  provider: StreamingEuDataProviders,
  selectedEntitlements: Set<StreamingEuDataProviders>,
  addOrRemoveProvider: (_provider: StreamingEuDataProviders, _checked: boolean) => void
) => {
  const checked = selectedEntitlements.has(provider);
  return (
    <div className={styles.checkBoxWrapper} key={`provider-${provider}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={() => addOrRemoveProvider(provider, !checked)}
        className={styles.inputSpace}
      />
      {StreamingEntitlementsTitles[provider]}
    </div>
  );
};

export const AccessToEntitlementData = ({
  navigateToStep,
  storeStreamingData,
}: StreamingEuStepDefaultProps) => {
  const [selectedProviders, setSelectedProviders] = useState(new Set<StreamingEuDataProviders>());

  const isDisabled = () => selectedProviders.size === 0;

  const setSingleProvider = (provider: StreamingEuDataProviders, checked: boolean) => {
    const newSet = new Set(selectedProviders);
    if (checked) {
      newSet.add(provider);
    } else {
      newSet.delete(provider);
    }
    setSelectedProviders(newSet);
  };

  const navigateForward = () => {
    if (isDisabled()) {
      return;
    }
    storeStreamingData({ requestedEntitlementData: [...selectedProviders] });
    navigateToStep(StreamingEuStep.TermsAndConditions);
  };

  return (
    <>
      <h1 className={styles.title}>{StreamingEuStepTitle.AccessToEntitlementData}</h1>
      <div>
        <p>{AccessEntitlementDataParagraph1}</p>
        <p>{AccessEntitlementDataParagraph2}</p>
      </div>
      <div className={styles.scrollBox}>
        {Object.values(StreamingEuDataProviders).map(provider =>
          renderInput(provider, selectedProviders, setSingleProvider)
        )}
      </div>
      <div className={styles.horizontalCentering}>
        <BasicButton
          as={"button"}
          onClick={navigateForward}
          disabled={isDisabled()}
          className={cx(commonStyles.primaryButton, styles.inputSpace)}
          textDecorationUnderline={true}
        >
          {StreamingButtonLabels.Submit}
        </BasicButton>
        <StreamingEuCloseButton />
      </div>
    </>
  );
};
